import { jsxs as $, Fragment as U, jsx as e } from "react/jsx-runtime";
const z = ({ block: t, editor: V, contentRef: W }) => {
  var h, m, f, g, w, u, x, y;
  const n = (h = t == null ? void 0 : t.props) == null ? void 0 : h.url, s = (m = t == null ? void 0 : t.props) == null ? void 0 : m.widthValue, i = (f = t == null ? void 0 : t.props) == null ? void 0 : f.widthUnit, r = ((g = t == null ? void 0 : t.props) == null ? void 0 : g.link) || "", j = ((w = t == null ? void 0 : t.props) == null ? void 0 : w.target) || "_self", p = ((u = t == null ? void 0 : t.props) == null ? void 0 : u.alt) || "", a = ((x = t == null ? void 0 : t.props) == null ? void 0 : x.title) || "", d = ((y = t == null ? void 0 : t.props) == null ? void 0 : y.caption) || "";
  return /* @__PURE__ */ $(U, { children: [
    !!r && /* @__PURE__ */ e(
      "a",
      {
        href: r,
        target: j,
        rel: "noopener noreferrer",
        style: {
          display: "contents"
        },
        children: /* @__PURE__ */ e(
          "img",
          {
            alt: p,
            title: a,
            style: {
              width: `${s}${i}`,
              maxWidth: "100%"
            },
            src: n
          }
        )
      }
    ),
    !r && /* @__PURE__ */ e(
      "img",
      {
        alt: p,
        title: a,
        style: {
          width: `${s}${i}`,
          maxWidth: "100%"
        },
        src: n
      }
    ),
    d && /* @__PURE__ */ $(
      "div",
      {
        style: {
          marginTop: "0.25rem",
          fontSize: "0.875rem",
          color: "#9ca3af"
        },
        children: [
          "▲ ",
          d
        ]
      }
    )
  ] });
};
export {
  z as Image
};
